import React, {useEffect} from "react";
import { Button, Result } from "antd";
import { useHistory } from 'react-router-dom';
import './PageErrorLayout.less';
import {Helmet} from "react-helmet";

export default function PageNotFoundLayout() {
    useEffect(() => {
    });

    const history = useHistory();
    function handleGoBack() {
        if (history.length >= 1) {
            history.go(-1);
        } else {
            history.push('/');
        }
    }

    return (
        <div className={'page-error-layout'}>
            <Helmet><title>{ `Page Not Found`}</title></Helmet>
            <Result
                status={'404'}
                title={'404 - Page Not Found'}
                subTitle={'Sorry, the page you are visiting does not exist.'}
                extra={<Button type={"primary"} onClick={handleGoBack}>Take me back</Button> }
            />
        </div>
    );
}

export function PageUnauthorizedLayout() {
    useEffect(() => {
    });

    const history = useHistory();
    function handleGoBack() {
        if (history.length >= 2) {
            history.go(-2);
        } else {
            history.push('/');
        }
    }

    return (
        <div className={'page-error-layout'}>
            <Helmet><title>{ `Unauthorized Access`}</title></Helmet>
            <Result
                status={'403'}
                title={'403 - Unauthorized'}
                subTitle={'Unfortunately, you are not authorized to use this page.'}
                extra={<Button type={"primary"} onClick={handleGoBack}>Take me back</Button>}
            />
        </div>
    );
}

export function PageInternalErrorLayout() {
    useEffect(() => {
    });

    const history = useHistory();
    function handleGoBack() {
        if (history.length >= 1) {
            history.go(-1);
        } else {
            history.go(0);
        }
    }

    return (
        <div className={'page-error-layout'}>
            <Helmet><title>{ `Server Error`}</title></Helmet>
            <Result
                status={'500'}
                title={'500 - Server Down'}
                subTitle={'Unfortunately, the server is down at this time, please try again later.'}
                extra={<Button type={"primary"} onClick={handleGoBack}>Try again</Button> }
            />
        </div>
    );
}
